import { JSX, useState } from 'react';
import { categories } from '../todolist/category/category';
import TodoManager from '../todolist/data/todoManager';
import TitleInput from '../common/title/title';
import TodoContent from '../todolist/add-todo/todoContent';
import AddButton from '../common/AddButton/addButton';
import { TodoTask } from '../todolist/add-todo/addTodoList';

const EditTodoContent = ({todo, setClosePage}: {todo: TodoTask, setClosePage:()=>void}): JSX.Element => {

    const [thisTodo, setThisTodo] = useState<TodoTask>(todo);

  const changeTodoTitle = (title: string) => {
    setThisTodo({ ...thisTodo, title: title});
  };

  const changeTodoContent = (content: string) => {
    setThisTodo({ ...thisTodo, content: content}); 
  };

  const changeTodoCategory = (category: categories) => {
    setThisTodo({ ...thisTodo, category: category}); 
  };

  const changeTodoDate = (date: Date) => {
    setThisTodo({ ...thisTodo, date: date}); 
  };

  const todoManager = TodoManager.getInstance();

  const updateTodo = async () => {
    try {
        await todoManager.updateTodo(thisTodo);
        setClosePage();
         // Success handling
    } catch (error) {
         console.log('update todo error')
    }
  };

  return (
    <div className='todo-container'>
      {/* Title */}
      <TitleInput title={thisTodo.title} setTitle={changeTodoTitle}/>
      {/* Content */}
      <TodoContent 
        todoContent={thisTodo.content} onContentChange={changeTodoContent}
        todoDate={thisTodo.date} onDateChange={changeTodoDate}
        todoCategory={thisTodo.category} onCategoryChange={changeTodoCategory}
      />
      {/* Add Button */}
      <AddButton title='Update' addFunction={() => {updateTodo()}}/>
    </div>
  ); 
};
  
export default EditTodoContent;